import React, { useEffect, useState ,useRef} from "react";
import { Box,Typography, useMediaQuery,Container ,Grid,Paper} from "@mui/material";
import Footer from "./Footer";



const insights = [
    "Gain visibility and deep insights into your business processes",
    "Understand potential issues and take rapid action to improve performance",
    "Have faster access to opportunities and threats from the markets",
    "Make quick decisions by having ready access to information in near real time",
  ];

const callouts = [
  { text: "Topology Analysis", top: "12%", left: "50%", rotate: "0deg", transform: "translateX(-50%)" },
  { text: "Logs and Unstructured Data", top: "34%", left: "8%", rotate: "-35deg" },
  { text: "Performance and Availability", bottom: "17%", left: "18%", rotate: "-72deg" },
  { text: "Capacity and Consumption", bottom: "17%", right: "18%", rotate: "72deg" },
  { text: "Configuration Health", top: "34%", right: "8%", rotate: "33deg" },
];



const serviceContents = [
    {
      title: "Predictive Risk Intelligence & Performance Management Solution (PRIM)",
      description:
        "The predictive capabilities of PRIM solution work as a risk intelligence & performance management solution that aid in preventing disasters, incidents and plant breakdowns.",
    },
    {
      title: "Business Intelligence Solution for Enterprise Asset Management (BEAM) and Asset Health Index (AHI)",
      description:
        "The solutions help improve operational efficiency, customer satisfaction, health and safety and capital investment planning.",
    },
    {
      title: "Insurance & Claims Engineering (ICE: Industry applicability - Insurance)",
      description:
        "ICE includes solutions that use advanced predictive analytics to improve operational processes and reduce leakage. This is achieved by gaining an insight into the insurance business resulting in time and cost savings.",
    },
  ];
  
  const analyticsContents = [
    {
        title: "Solutions include:",
        description: [
          "Insurance Customer Analytics: It is customer-centric toward areas like prospecting, acquisition, retention for models like loss, profitability, risk and renewal rate.",
          "Subrogation Solution: It covers areas around pre-claims, first notice of loss, recoveries and claim performance.",
        ],
      },
    {
      title: "Fraud Analytics (Industry applicability - Banking)",
      description:
        "It helps in prevention, detection, deterrence, remediation and investigation of frauds through continual analysis of pre-defined key factors.",
    },
    {
      title: "Store Analytics (Industry applicability - Retail)",
      description:
        "It helps with payroll optimization, fraud reduction and operational expense optimization. This, when coupled with our Supply Chain Solutions, results in improvement in operational efficiency, fraud reduction, cost savings and overall optimization of supply chain.",
    },
   
  ];
  
  const operationalContents = [
    {
      title: "Proactive Asset Life Cycle Management (PALM: Industry applicability - Energy and Utilities)",
      description:
        "PALM encompasses a range of analytical solutions that cater to different areas of the asset life cycle. These solutions aid effective asset maintenance as well as workforce management while ensuring that health & safety norms are being met.",
    },
    {
      title: "Actionable Insights for Retail (Applicability for Retail and CPG)",
      description:
        "This is an integrated set of analytical applications for retailers embarking on integrated multi-channel marketing, real-time offerings or new market entry. The solution has unique features such as actionable insights on lead generation using third-party data along with CRM data (using universal persona technique), and attrition drivers using open-source data.",
    },
  ];
  
  const contentSections = [
    { content: serviceContents, image: "/image/op1.jpg" },
    { content: analyticsContents, image: "/image/op3.jpg" },
    { content: operationalContents, image: "/image/op2.jpg" },
  ];


const PentagonDiagram = () => {
    const isMobile = useMediaQuery("(max-width: 768px)");
  const [firstAnimationVisible, setFirstAnimationVisible] = useState(false);
  const [secondAnimationVisible, setSecondAnimationVisible] = useState(false);
  const [visibleBoxes, setVisibleBoxes] = useState([]);

  const firstSectionRef = useRef(null);
  const secondSectionRef = useRef(null);


  
       useEffect(() => {
              window.scrollTo(0, 0); // Scroll to top when component loads
            },[]);

  // Observer for First Section (Four Circles)
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setFirstAnimationVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );

    if (firstSectionRef.current) {
      observer.observe(firstSectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  // Observer for Second Section (Center Circle & Callouts)
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setSecondAnimationVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );

    if (secondSectionRef.current) {
      observer.observe(secondSectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  // Staggered Callout Box Animations
  useEffect(() => {
    if (secondAnimationVisible) {
      callouts.forEach((_, index) => {
        setTimeout(() => {
          setVisibleBoxes((prev) => [...prev, index]);
        }, index * 500);
      });
    }
  }, [secondAnimationVisible]);


  return (
    <>
      {/* First Section - Background Image */}
      <Box
  sx={{
    position: "relative",
    width: "100%",
    minHeight: "100vh", // Use minHeight instead of fixed height
    backgroundImage: `url("/image/operational.jpg")`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    color: "white",
    overflow: "hidden", // Prevents content from spilling over
  }}
>
  {/* Dark overlay for readability */}
  <Box
    sx={{
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
    }}
  />

  {/* Content Box */}
  <Box
    sx={{
      position: "relative",
      maxWidth: "700px",
      marginLeft: { xs: "3%", md: "8%" },
      marginTop: { xs: "15%", md: "10%" }, // Reduce margin to avoid overflow
      zIndex: 1,
      padding: 4,
      
    }}
  >
    <Typography 
      variant="h3" 
      sx={{ 
        fontWeight: "bold", 
        mb: 2, 
        fontSize: { xs: "28px", md: "42px" }, // Reduce size slightly for better fit
      }}
    >
     Operational Analytics
    </Typography>
    <Typography 
      variant="body1" 
      sx={{ 
        fontSize: { xs: "14px", md: "18px" }, 
        maxWidth: "100%", 
        wordBreak: "break-word", 
        lineHeight: 1.5, 
      }}
    >
   Operational Analytics enables near real-time analysis of processes, thereby helping you to optimize your operations by efficiently identifying and isolating inefficiencies and failures. The data for decision making and discovery may be derived from different sources such as your internal database or externally from social media platforms. It can be hosted over the cloud and can be accessed through mobile devices. Business analytics coupled with data mining, self-service, predictive analytics and aggregation tools is used to get more transparent information for critical decision making and implementing decision support system.
    </Typography>
  </Box>
</Box>




{/*second section*/}



<Box
  sx={{
    backgroundImage: `url("/image/blue1.jpg")`, // Ensure the correct path
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundAttachment: "fixed", // Parallax effect
    py: 6,
    px: 2,
    textAlign: "center",
    minHeight: "60vh",
  }}
>
  <Container maxWidth="md" sx={{ mb: 4 }}>
    <Typography
      variant="h2"
      sx={{
        fontWeight: "bold",
        color: "black",
        fontSize: {
          xs: "1.8rem",
          sm: "2.2rem",
          md: "2.5rem",
          lg: "3rem",
          xl: "3.5rem",
        },
        textAlign: "center",
        mt: 2,
      }}
    >
      How Tech Informatic Solutions Helps
    </Typography>
    <Typography
      variant="body1"
      sx={{ lineHeight: 1.6, fontSize: isMobile ? "1rem" : "1.2rem", mt: 2, color: "black" }}
    >
      Tech Informatic Solutions its clients to improve the existing operations of their organizations.
    </Typography>
    <Typography
      variant="body1"
      sx={{ lineHeight: 1.6, fontSize: isMobile ? "1.2rem" : "1.5rem", mt: 2, color: "black", fontWeight: "bold" }}
    >
      Our Operational Analytics Service helps you:
    </Typography>
  </Container>

  {/* First Animation - Four Circles */}
  <Box
    ref={firstSectionRef}
    sx={{
      width: "100%",
      display: "flex",
      flexDirection: isMobile ? "column" : "row",
      alignItems: "center",
      justifyContent: "center",
      gap: isMobile ? "30px" : "50px",
      px: "20px",
    }}
  >
    {insights.map((text, index) => (
      <Box
        key={index}
        sx={{
          width: isMobile ? "150px" : "200px",
          height: isMobile ? "150px" : "200px",
          borderRadius: "50%",
          background: "linear-gradient(145deg, #1F6788, black)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          color: "#fff",
          fontSize: isMobile ? "12px" : "16px",
          fontWeight: "bold",
          padding: "10px",
          boxShadow: `0px 12px 25px rgba(0, 0, 0, 0.6),
            inset 0px 10px 20px rgba(255, 255, 255, 0.15),
            inset 0px -10px 30px rgba(0, 0, 0, 0.7)`,
          opacity: firstAnimationVisible ? 1 : 0,
          transform: firstAnimationVisible ? "scale(1)" : "scale(0.5)",
          transition: `opacity 0.8s ease ${index * 0.3}s, transform 0.8s ease ${index * 0.3}s`,
        }}
      >
        <Typography variant="body1">{text}</Typography>
      </Box>
    ))}
  </Box>

  {/* Text Section */}
  <Box
  sx={{
    width: "100%",
    textAlign: "left",
    padding: isMobile ? "20px" : "50px",
    boxSizing: "border-box",
  }}
>
  <Typography
    variant="body1"
    sx={{
      lineHeight: 1.6,
      fontSize: isMobile ? "1rem" : "1.2rem",
      mt: 2,
      color: "black",
    }}
  >
 With our Joint Innovation Council, Analytics Lab On Hire, Centre of Excellence (CoE), Special Interest Group and a community for the purpose of research and strategy development, we have developed a new business capabilities approach which is targeted towards a specific domain. This use advanced analytical models that provide new insights into customer behavior, propensity to purchase, validate the model through internal and real world data and ensure the model's fidelity.  </Typography>
</Box>


  {/* Second Animation - Pentagon Diagram */}
  <Box
    ref={secondSectionRef}
    sx={{
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <Box
      sx={{
        position: "relative",
        width: isMobile ? "350px" : "800px",
        height: isMobile ? "350px" : "800px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        perspective: "1200px",
      }}
    >
      {/* Center Circle */}
      <Box
        sx={{
          width: isMobile ? "90px" : "250px",
          height: isMobile ? "90px" : "250px",
          borderRadius: "50%",
          background: "linear-gradient(145deg, red, black)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "white",
          fontWeight: "bold",
          textAlign: "center",
          fontSize: isMobile ? "10px" : "18px",
          boxShadow: `0px 12px 25px rgba(0, 0, 0, 0.6),
            inset 0px 10px 20px rgba(255, 255, 255, 0.15),
            inset 0px -10px 30px rgba(0, 0, 0, 0.7)`,
          opacity: secondAnimationVisible ? 1 : 0,
          transform: secondAnimationVisible ? "scale(1)" : "scale(0.5)",
          transition: "opacity 1s ease-out, transform 1s ease-out",
        }}
      >
        OPERATIONAL ANALYTICS
      </Box>

      {/* Callout Boxes */}
      {callouts.map((callout, index) => (
        <Box
        key={index}
        sx={{
          position: "absolute",
          width: isMobile ? "70px" : "180px",
          height: isMobile ? "70px" : "120px",
          background: "linear-gradient(145deg, #1F6788, black)",
          borderRadius: "12px",
          textAlign: "center",
          color: "white",
          fontSize: isMobile ? "10px" : "16px",
          fontWeight: "bold",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          paddingTop: isMobile ? "3px" : "8px",
          boxShadow: `
            0px 12px 25px rgba(0, 0, 0, 0.6),  
            inset 0px 10px 20px rgba(255, 255, 255, 0.15),
            inset 0px -10px 30px rgba(0, 0, 0, 0.7),
            inset 10px 0px 20px rgba(0, 0, 0, 0.5), 
            inset -10px 0px 20px rgba(255, 255, 255, 0.2),
            inset 15px 15px 20px rgba(0, 0, 0, 0.6),  
            inset -15px -15px 20px rgba(255, 255, 255, 0.2)
          `,
          opacity: visibleBoxes.includes(index) ? 1 : 0,
          transform: visibleBoxes.includes(index)
            ? `rotate(${callout.rotate}) scale(1)`
            : `rotate(${callout.rotate}) scale(0.5)`,
          transition: `opacity 0.8s ease-out ${index * 0.3}s, transform 0.8s ease-out ${index * 0.3}s`,
          ...callout,
        }}
      >
        <Box
          sx={{
            transform:
              callout.text === "Performance and Availability" || callout.text === "Capacity and Consumption"
                ? "rotate(180deg)" // Flip text only for these two boxes
                : "none",
          }}
        >
          {callout.text}
          </Box>
            <Box
              sx={{
                position: "absolute",
                bottom: isMobile ? "-10px" : "-15px",
                width: "0px",
                height: "0px",
                left: "50%", // Centering horizontally
                transform: "translateX(-50%)", // Adjusting to truly center
               
                borderLeft: isMobile ? "6px solid transparent" : "12px solid transparent",
                borderRight: isMobile ? "6px solid transparent" : "12px solid transparent",
                borderTop: isMobile ? "10px solid #9C1218" : "15px solid #9C1218",
                //transform: "translateZ(10px)",
                opacity: visibleBoxes.includes(index) ? 1 : 0,
                transition: `opacity 0.5s ease-out`,
            }}
            />
          </Box>
        
      ))}
    </Box>
  </Box>


      <Box
  sx={{
    width: "100%",
    textAlign: "left",
    padding: isMobile ? "20px" : "50px",
    boxSizing: "border-box",
  }}
>
  <Typography
    variant="body1"
    sx={{
      lineHeight: 1.6,
      fontSize: isMobile ? "1rem" : "1.2rem",
      mt: 2,
      color: "black",
    }}
  >
Operational Analytics shifts the focus from simply understanding data to taking action on it in the tools that run business processes. Instead of using dashboards to make decisions, Operational Analytics is focused on turning insights into action – automatically.

</Typography>
<Typography
    variant="body1"
    sx={{
      lineHeight: 1.6,
      fontSize: isMobile ? "1rem" : "1.2rem",
      mt: 2,
      color: "black",
      
    }}
  >
When all your data is stored in your data warehouse, it's only accessible to your technical users who know how to write SQL. Your business teams across sales, marketing, support, and product can't leverage this data in any meaningful way other than looking at it through a report. 
</Typography>
</Box>

<Box
      sx={{
        p: isMobile ? 3 : 7,
        textAlign: "justify",
        backgroundColor: "none",
        width: "100%",
        overflow: "hidden",
        boxSizing: "border-box",
      }}
    >
      <Grid
        container
        justifyContent="center"
        alignItems="stretch"
        spacing={3}
        sx={{
          mt: 4,
          mb: 4,
          px: isMobile ? 2 : 4,
          maxWidth: "100%",
          margin: "0 auto",
        }}
      >
        {contentSections.map((section, index) => (
          <Grid item xs={12} sm={6} md={4} key={index} sx={{ display: "flex", maxWidth: "100%" }}>
            <Paper
              elevation={5}
              sx={{
                position: "relative",
                borderRadius: "15px",
                width: "100%",
                minHeight: "500px",
                height: "auto",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                padding: "20px",
                backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url(${section.image})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                transition: "all 0.5s ease-in-out",
                "&:hover": {
                  backgroundImage: `linear-gradient(#1F6788, black), url(${section.image})`,
                },
                "&:hover .content": { opacity: 1 },
                "&:hover .default-title": { opacity: 0 },
                "& .content": { opacity: 0, transition: "opacity 0.5s ease-in-out" },
                "& .default-title": { opacity: 1, transition: "opacity 0.5s ease-in-out" },
              }}
            >
              {/* Content Inside the Paper */}
              <Box className="content" sx={{ width: "100%", textAlign: "center", mt: 2 }}>
                <Box sx={{ mt: 1, px: 2 }}>
                  {section.content.map((item, i) => (
                    <Box key={i} sx={{ mb: 2 }}>
                      <Typography
                        variant="h6"
                        sx={{
                          fontFamily: "Roboto",
                          fontWeight: "bold",
                          textAlign: "left",
                          fontSize: isMobile ? "16px" : "18px",
                          color: "orange",
                          mb: 1,
                        }}
                      >
                        {item.title}
                      </Typography>
                      {Array.isArray(item.description) ? (
                        item.description.map((point, j) => (
                          <Typography
                            key={j}
                            variant="body2"
                            sx={{
                              fontFamily: "Roboto",
                              lineHeight: "1.8",
                              textAlign: "left",
                              fontSize: isMobile ? "14px" : "16px",
                              color: "white",
                              mb: 1,
                              display: "flex",
                            }}
                          >
                            <span
                              style={{
                                fontSize: isMobile ? "16px" : "18px",
                                fontWeight: "bold",
                                color: "orange",
                                marginRight: "8px",
                                display: "inline-block",
                              }}
                            >
                              •
                            </span>
                            <span style={{ flex: 1 }}>{point}</span>
                          </Typography>
                        ))
                      ) : (
                        <Typography
                          variant="body2"
                          sx={{
                            fontFamily: "Roboto",
                            lineHeight: "1.8",
                            textAlign: "left",
                            fontSize: isMobile ? "14px" : "16px",
                            color: "white",
                          }}
                        >
                          {item.description}
                        </Typography>
                      )}
                    </Box>
                  ))}
                </Box>
              </Box>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>



      </Box>
      


    


    <Footer/>
    </>
  );
};
export default PentagonDiagram;